/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Login page
  Date: August 2020
**/

import React from 'react';
import {
  makeStyles,
  Typography,
  Grid
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
import LocalStorageService from '../../services/localStorage';
const localStorageService = LocalStorageService.getService();

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  }
}));

const SsoCorporate = (props) => {
  const classes = useStyles();
  const userAction = useStoreActions((actions) => actions.login);
  const customizeAction = useStoreActions((actions) => actions.customize);

  // SSO LOGIN REDIRECT
  let params = new URLSearchParams(props.location.search);
  let params2 = props.match.params.id;
  
  const getSSOLoginResponse = () => {   
    userAction.getUserInfo();
    customizeAction
      .getConfigData()
      .then(function (responseData) {
        customizeAction.setConfigData(responseData.data.data.config);
        userAction.setUserName(responseData.data.data.body.userData.username);
        props.history.push('/');
      })
      .catch(function (error) {
        customizeAction.setConfigData({});
      });
  }  
  
  userAction.azureLogin({ 'code': params.get('code'), 'provider': params2 })
    .then(function (response) {
      const azureResponseData = response;
      if (azureResponseData && azureResponseData.data && azureResponseData.data.success) {
        userAction.ssoLogin({ 'access_token': azureResponseData.data.data.access_token })
          .then(function (response) {
            localStorageService.setLoginInfo({
              accessToken: azureResponseData.data.data.access_token,
              refreshToken: azureResponseData.data.data.refresh_token,
              clientID: azureResponseData.data.data.client_id,
              // username: values.username,
              tokenTimestamp: Date.now(),
              provider: params2,
            });
            getSSOLoginResponse();
          })
          .catch(function (error) {
            props.history.push('/login');
          });
      }
    })
    .catch(function (error) {
      // console.log("error", error);
      props.history.push('/login');
    });

  return (
    <Grid container component="main" className={classes.root}>
      <Grid item xs={12}>
        <Typography
          variant="h2"
          style={{
            textAlign: 'center',
            marginTop: '100px',
            fontWeight: '600',
            padding: '10px 0px',
            border: '0px solid #ccc',
            width: '100%',
          }}
        >
          Redirecting to Application
        </Typography>
      </Grid>
    </Grid>
  );
};

export default withRouter(SsoCorporate);
